import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ActorService } from '../../../../services/actor.service';
import { AppData } from '../../../../models/appdata';
import { SaveTestInformationRequest, TestInformationData } from '../../../../models/lab/testinfo.model';
import { NGXToastrService } from '../../../../../shared/services/toastr.service';

@Component({
  selector: 'ngbedittestinfo',
  templateUrl: './edittestinfo.modal.html',
  styleUrls: ['./edittestinfo.modal.scss']
})

export class NgbEditTestinfoModal implements OnInit {
  @Input() TestInfo: TestInformationData;
  public ShowList: boolean = true; 

  public model: TestInformationData = {
    TestCode: 1,
    ServiceCode: 16,
    Name: 'ACA IGG',
    ShortName: 'ACAIGG',
    DepartmentName: 'Serology',
    PatientAgeProfile: 'Female',
    TestAvailability: 'External Lab',
    ServiceMapping: '16',
    TestType: 'General'
  };

  constructor(
    public activeModal: NgbActiveModal,
    private actorService: ActorService,
    private toastrService: NGXToastrService
  ) { }

  ngOnInit() {
    if (this.TestInfo) {
      this.model = { ...this.TestInfo };
    }
  }

  onSubmit() {
    const req = new SaveTestInformationRequest();
    req.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    req.TestCode = this.model.TestCode;
    req.ServiceCode = this.model.ServiceCode;
    req.Name = this.model.Name;
    req.ShortName = this.model.ShortName;
    req.DepartmentName = this.model.DepartmentName;
    req.PatientAgeProfile = this.model.PatientAgeProfile;
    req.TestAvailability = this.model.TestAvailability;
    req.ServiceMapping = this.model.ServiceMapping;
    req.TestType = this.model.TestType;

    this.actorService.SaveTestInformation(req).subscribe(
      (res) => {
        this.toastrService.ToasterSuccessAlertParam('Test Information Saved Successfully!');
        this.activeModal.close(this.model);
      },
      (err) => {
        this.toastrService.ToasterSuccessAlertParam('Test Information Saved Successfully!');
        this.activeModal.close(this.model);
      }
    );
  }

  ModalClose() {
    this.activeModal.dismiss();
  }
}
